var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "42px",
    height: "34px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "42px",
    height: "34px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAiBAMAAADbvlYFAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAElBMVEWKrsaKrsZWbHs0QksAAAD///9gLLsXAAAABHRSTlMAWKPTS8x11gAAAAFiS0dEBfhv6ccAAAAHdElNRQfoAhQWDyw+kw8JAAAAbElEQVQoz8WQ0Q2AIAxEjw2o6Qa6ACMQ2H8mSz9sU/HDBON9vhy5VwAQEe7hXh8p+VyUu6UupPO1N75fUW9llN0FK+l87c9/IBIqPt4KONS96RX2ZlNaAk2j3HKgWi6IVMpSDWujXCa+ac8RnQccNQBBprjbAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort2);
export default __webpack_public_path__ + "static/media/sort-2.d924c116a50ac62723b1bbebaa8bbadd.svg";
export { ForwardRef as ReactComponent };